import { all, fork, take, call, cancel, select } from 'redux-saga/effects';

import mfaSaga from './sagas/mfa';
import authSaga from './sagas/auth';
import chatSaga from './sagas/chat';
import coachSaga from './sagas/coach';
import audioSaga from './sagas/audio';
import assetSaga from './sagas/asset';
import reviewSaga from './sagas/review';
import activitySaga from './sagas/activity';
import taxonomySaga from './sagas/taxonomy';
import productionSaga from './sagas/production';
import teamProfileSaga from './sagas/teamProfile';
import notificationSaga from './sagas/notification';
import coachConsoleSaga from './sagas/coachConsole';
import coachInsightsSaga from './sagas/coachInsights';
import { logout, sessionExpired } from './slices/auth';
import supportConsoleSaga from './sagas/supportConsole';
import notificationFrameworkSaga from './sagas/notificationFramework';
import { releaseAllAttachments } from '../sections/support/pendingAttachments';

export function* panelSessionSaga() {
  for (;;) {
    while (!(yield select((state) => state.auth.isAuthenticated))) yield take('*');
    const task = yield fork(function* panelWatchers() {
      yield all([
        coachInsightsSaga(),
        chatSaga(),
        coachSaga(),
        coachConsoleSaga(),
        supportConsoleSaga(),
        productionSaga(),
        teamProfileSaga(),
      ]);
    });
    yield take([logout.type, sessionExpired.type]);
    yield cancel(task);
    yield call(releaseAllAttachments);
  }
}

export default function* rootSaga() {
  yield all([
    authSaga(),
    panelSessionSaga(),
    audioSaga(),
    reviewSaga(),
    assetSaga(),
    activitySaga(),
    taxonomySaga(),
    notificationSaga(),
    notificationFrameworkSaga(),
    mfaSaga(),
  ]);
}
